import styled from 'styled-components';

export const Container = styled.div`
  .sound-option {
    display: inline-flex;
    align-items: center;
    margin: 0 32px 8px 0;
  }

  select {
    width: auto;
    margin: 0 6px;
  }

  .btn .material-icons {
    font-size: 16px;
    vertical-align: middle;
  }
`;
